module.exports = __webpack_public_path__ + "img/blackboald.1d2cebfb.png";